import { gql } from '@apollo/client'
import { MUTATION_STATE } from '../../fragments'

const PAYLOAD = 'UpdateVoohCreationSchedulesPayload'

export const UPDATE_VOOH_CREATION_SCHEDULES = gql`
  ${MUTATION_STATE(PAYLOAD)}
  mutation updateVoohCreationSchedule($voohCreationId: ID!, $schedules: [CreationScheduleInput!]!) {
    updateVoohCreationSchedules(input: { voohCreationId: $voohCreationId, schedules: $schedules }) {
      ...MutationState${PAYLOAD}Fields
    }
  }
`
